export default __webpack_public_path__ + "static/media/bce0ded315907e13.d8993b1700a92f987ef1a8d67c25b1a9.svg";